
import { Helmet } from 'react-helmet'
import Footer from '../../../Components/Footer'
import Header from '../../../Components/Header'
import MainContent from './MainContent'

const BomList = () => {
  
  return (
    <div className='d-flex flex-column' style={{ minHeight: '99.9vh' }}>
      <Helmet>
				<title>BOM List</title>
			</Helmet>
    <Header />
    <MainContent />
    {/* <Footer /> */}
    </div>
  )
}

export default BomList